/*
 * API
 * needLoading: { Boolean } 是否需要请求加载时的loading组件
 * disableClose: { Boolean } 是否需要关闭弹窗|toast|message等
 */
import service from '@/utils/request'

const info = params => {
  return service.get('/api/info', { params: params, needLoading: true, disableClose: true })
}
const refreshPool = body => {
  return service.post('/api/refresh_pool', body, { needLoading: true })
}
const refreshDiscount = body => {
  return service.post('/api/refresh_discount', body, { needLoading: false })
}
const purchase = body => {
  return service.post('/api/purchase', body, { needLoading: true })
}

const policyCheck = body => {
  return service.post('/api/policy_check', body, { needLoading: true })
}

const googlePolicyCheck = body => {
  return service.post('/api/google_analytics_check', body, { needLoading: true, opacity: true })
}

export default {
  info,
  refreshPool,
  refreshDiscount,
  purchase,
  policyCheck,
  googlePolicyCheck
}



// WEBPACK FOOTER //
// ./src/api/index.js